import type { ConsentState } from './types';

export const COOKIE_CONSENT_KEY = 'cookie-consent';

export const DEFAULT_CONSENT: ConsentState = {
  necessary: true,
  analytics: process.env.NODE_ENV === 'development',
  marketing: process.env.NODE_ENV === 'development',
  preferences: process.env.NODE_ENV === 'development',
};

export function parseConsentCookieValue(
  cookieValue: string | null | undefined,
): ConsentState {
  if (!cookieValue) {
    return DEFAULT_CONSENT;
  }

  try {
    const parsed = JSON.parse(decodeURIComponent(cookieValue));

    return {
      necessary: true,
      analytics: parsed.analytics === true,
      marketing: parsed.marketing === true,
      preferences: parsed.preferences === true,
      timestamp: parsed.timestamp ? new Date(parsed.timestamp) : new Date(),
    };
  } catch (error) {
    console.error('Failed to parse consent cookie:', error);
    return DEFAULT_CONSENT;
  }
}
